export const templateTypeName = 'Template'
